/* RB Store stock: keeps the per-store availability line and table in sync with the selected size. */
if (!customElements.get('rb-store-stock')) {
  customElements.define(
    'rb-store-stock',
    class RbStoreStock extends HTMLElement {
      connectedCallback() {
        // Carl 1 Oct (evening): the "In store" line sits with Free delivery / Client Care under Add to bag.
        // Moving the element re-runs connectedCallback, so the rest of the set-up happens on that second pass.
        if (this.dataset.mode === 'line' && !this.dataset.rbPlaced && this.place()) return;
        try {
          this.data = JSON.parse(this.querySelector('[data-rb-store-stock-data]').textContent);
        } catch (e) {
          this.data = {};
        }
        this.labels = { in: this.dataset.lIn, low: this.dataset.lLow, out: this.dataset.lOut };
        this.scope = this.closest('product-info') || document;

        // Theme event (Dawn pub/sub) fired after the section re-renders for a new variant.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event && event.data;
            if (!data || (this.dataset.section && data.sectionId && data.sectionId !== this.dataset.section)) return;
            this.update(data.variant ? data.variant.id : null);
          });
        }

        // Fallback: the hidden variant id input in the product form changes on every size switch.
        this.onInputChange = (event) => {
          const target = event.target;
          if (!target || !target.matches || !target.matches('input[name="id"]')) return;
          if (!target.closest('form[data-type="add-to-cart-form"]')) return;
          if (this.scope !== document && !this.scope.contains(target)) return;
          this.update(target.value);
        };
        document.addEventListener('change', this.onInputChange);

        if (this.dataset.mode === 'line') this.mountAccordion();
        if (this.dataset.mode === 'table') this.bindToggle();
        if (this.dataset.mode === 'table') this.sortRows();
      }

      place() {
        const scope = this.closest('product-info');
        if (!scope) return false;
        const assist = scope.querySelector('.rb-pdp-assist');
        if (!assist) {
          // the assist block is further down the page and may not be parsed yet
          if (document.readyState === 'loading' && !this.waiting) {
            this.waiting = true;
            document.addEventListener('DOMContentLoaded', () => {
              if (this.dataset.rbPlaced) return;
              const a = scope.querySelector('.rb-pdp-assist');
              if (!a) return;
              this.dataset.rbPlaced = 'true';
              this.classList.add('rb-store-stock--assist');
              a.appendChild(this);
            });
          }
          return false;
        }
        this.dataset.rbPlaced = 'true';
        this.classList.add('rb-store-stock--assist');
        assist.appendChild(this);
        return true;
      }

      // 'auto' mode: move the all-sizes accordion into this product's info accordions (first in the list).
      mountAccordion() {
        const tpl = this.querySelector('template[data-rb-accordion]');
        if (!tpl || this.scope === document) return;
        const container = this.scope.querySelector('.product-info-accordion-container');
        if (!container || container.querySelector('.rb-store-stock-accordion')) return;
        container.prepend(tpl.content.cloneNode(true));
      }

      // Own toggle, styled like the theme's accordions (the theme only binds buttons with data-accordion).
      bindToggle() {
        const accordion = this.closest('.rb-store-stock-accordion');
        const button = accordion && accordion.querySelector('[data-rb-toggle]');
        if (!button || button.dataset.rbBound) return;
        button.dataset.rbBound = 'true';
        button.addEventListener('click', () => {
          const content = button.nextElementSibling;
          const icon = button.querySelector('.accordion-icon');
          const open = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(open));
          content.setAttribute('aria-hidden', String(!open));
          content.style.maxHeight = open ? content.scrollHeight + 'px' : '0px';
          content.style.overflow = open ? 'visible' : 'hidden';
          if (icon) icon.textContent = open ? '−' : '+';
        });
      }

      // sizes in numeric order (variant order in admin can put 44 after 56)
      sortRows() {
        const body = this.querySelector('tbody');
        if (!body) return;
        const rows = Array.from(body.querySelectorAll('tr[data-variant-id]'));
        const num = (r) => parseFloat((r.querySelector('th') || r).textContent.replace(',', '.'));
        if (!rows.length || rows.some((r) => isNaN(num(r)))) return;
        rows.sort((a, b) => num(a) - num(b)).forEach((r) => body.appendChild(r));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        document.removeEventListener('change', this.onInputChange);
      }

      update(variantId) {
        const id = variantId ? String(variantId) : '';
        if (id && id === this.currentId) return;
        this.currentId = id;
        const entry = id ? this.data[id] : null;

        if (this.dataset.mode === 'line') {
          const line = this.querySelector('[data-line]');
          if (!line) return;
          if (!entry || !entry.s) {
            line.hidden = true;
            return;
          }
          this.setStore(line.querySelector('[data-store="s"]'), entry.s);
          this.setStore(line.querySelector('[data-store="z"]'), entry.z);
          line.hidden = false;
          return;
        }

        // Table: show the sizes of the current colour, mark the selected size.
        this.querySelectorAll('tbody tr[data-variant-id]').forEach((row) => {
          if (entry) row.hidden = row.dataset.group !== entry.g;
          if (row.dataset.variantId === id) row.setAttribute('aria-current', 'true');
          else row.removeAttribute('aria-current');
        });
      }

      setStore(el, level) {
        if (!el) return;
        const dot = el.querySelector('[data-dot]');
        const text = el.querySelector('[data-text]');
        if (dot) dot.className = 'rb-dot rb-dot--' + level;
        if (text) text.textContent = this.labels[level] || '';
      }
    }
  );
}
